import {IonicErrorHandler} from 'ionic-angular';
import Raven from 'raven-js';

Raven
  .config('https://f023da5655444397824fc588dad52cc8@sentry.io/171308')
  .install();

export class SentryErrorHandler extends IonicErrorHandler {

  handleError(error) {
    super.handleError(error);

    try {
      Raven.captureException(error.originalError || error);
    }
    catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/sentry-errorhandler.ts